import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { http } from '../../network'
import { toast } from 'react-toastify'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { Button, Grid } from '@material-ui/core'
import UserModal from './userModal'
import { isAdminUser } from '../../utils'

const Users = () => {
    const [users, setUsers] = useState([])
    const [userToEdit, setUserToEdit] = useState({})
    const [addModal, setAddModal] = useState(false)

    const getAllUsers = useCallback(async () => {
        try {
            const users = await http.get('/all-users')
            setUsers(users?.data?.users)
        } catch (error) {
            toast.error('Error while fetching users')
        }
    }, [])

    const tableColumns = useMemo(() => [
        { id: 'no', label: '#', width: 50 },
        { id: 'email', label: 'Email', minWidth: 170 },
        { id: 'first_name', label: 'First Name', minWidth: 100 },
        {
            id: 'last_name',
            label: 'Last Name',
            minWidth: 170,
            align: 'right',
        },
        {
            id: 'role',
            label: 'Role',
            minWidth: 170,
            align: 'right',
        },
        isAdminUser() && {
            id: 'edit',
            label: 'Action',
            minWidth: 170,
            align: 'right',
        },
    ], [])

    useEffect(() => {
        getAllUsers()
    }, [])

    const editUser = (value) => {
        setUserToEdit(value)
        setAddModal(true)
    }

    const confirmDelete = (row) => {
        const allow = confirm('Are you sure you want to delete this user?')
        if (allow) {
            deleteUser(row)
        }
    }

    const deleteUser = async (value) => {
        try {
            await http.delete(`/user/${value._id}`)
            getAllUsers()
        } catch (error) {
            toast.error('Error while deleting users')
        }
    }

    const onModalClose = () => {
        setUserToEdit({})
        setAddModal(false)
    }

    const addNewUser = () => {
        setAddModal(true)
    }

    const renderColumn = (column, idx, row) => {
        const value = row[column.id]
        let content = value
        if (column.id === 'edit' && isAdminUser()) {
            content = <>
                <Button onClick={() => editUser(row)} variant='contained' size='small'>
                    Edit
                </Button>
                <Button style={{ marginLeft: 5 }} onClick={() => confirmDelete(row)} variant='contained' size='small'>
                    Delete
                </Button>
            </>
        }
        return <TableCell key={column.id + idx} align={column.align}>
            {column.id === 'no' ? idx + 1 : null}
            {content}
        </TableCell>
    }

    return (
        <>
            <Grid style={{ marginLeft: 'auto', marginTop: 2, marginBottom: 2 }}>
                <Button onClick={addNewUser} variant='contained' size='small'>
                    Add User
                </Button>
            </Grid>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label='sticky table'>
                    <TableHead>
                        <TableRow>
                            {tableColumns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users?.map((row, idx) => {
                            return (
                                <TableRow hover role='checkbox' tabIndex={-1} key={row.id}>
                                    {tableColumns.map((column) => {
                                        return renderColumn(column, idx, row)
                                    })}
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <UserModal getAllUsers={getAllUsers} open={addModal} userDetails={userToEdit} onModalClose={onModalClose} />
        </>
    )
}

export default Users
